import { useEffect, useState } from "react";
import { Award } from "lucide-react";
import { api } from "../../lib/api";
import { ClanLogo } from "./ClanLogo";

const fmt = (d) => new Date(`${d}T00:00:00Z`).toLocaleDateString(undefined, { month: "short", day: "numeric", timeZone: "UTC" });
const endInclusive = (d) => { const x = new Date(`${d}T00:00:00Z`); x.setUTCDate(x.getUTCDate() - 1); return x.toISOString().slice(0, 10); };

export function BadgeCard({ award }) {
  return (
    <div className="border border-amber-400/50 bg-amber-400/5 p-4 flex items-center gap-4 hardcore-badge" data-testid={`badge-${award.key}-${award.window_start}`}>
      <div className="relative">
        <ClanLogo logo={award.logo} size={48} />
        <Award className="w-5 h-5 text-amber-300 absolute -bottom-1.5 -right-1.5 drop-shadow-[0_0_6px_rgba(252,211,77,0.9)]" />
      </div>
      <div className="min-w-0">
        <div className="text-[10px] tracking-[0.3em] text-amber-300">{award.title.toUpperCase()}</div>
        <div className="text-sm font-bold truncate">{award.label} · {award.clan_name}</div>
        <div className="text-[11px] text-muted-foreground">
          {fmt(award.window_start)} – {fmt(endInclusive(award.window_end))} · score {award.score} · {award.rivals} clan{award.rivals === 1 ? "" : "s"} competing
        </div>
      </div>
    </div>
  );
}

export function BadgeList({ endpoint, title, emptyText, testid }) {
  const [awards, setAwards] = useState(null);
  useEffect(() => {
    api.get(endpoint).then((r) => setAwards(r.data)).catch(() => setAwards([]));
  }, [endpoint]);
  return (
    <div className="panel p-6" data-testid={testid}>
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-xl font-bold">{title}</h2>
        <span className="text-[10px] tracking-widest text-muted-foreground">{awards?.length || 0} EARNED</span>
      </div>
      {!awards || awards.length === 0 ? (
        <div className="text-sm text-muted-foreground" data-testid={`${testid}-empty`}>{emptyText}</div>
      ) : (
        <div className="grid sm:grid-cols-2 gap-3">{awards.map((a) => <BadgeCard key={`${a.key}-${a.window_start}`} award={a} />)}</div>
      )}
    </div>
  );
}
